import React from "react"
import { connect } from "react-redux"
import { getFormValues , change } from "redux-form"
import { SecondaryButton , AnalyticEvent } from '../components/forms'

const LinkButton = (props) => {
    return (
        <a href={props.href} type="button"
           onClick={() => {
               AnalyticEvent(window.dataLayer, props.analytics).then(()=> {}, () => {});
           }}
           className="button button--fullwidth">{props.children}</a>
    )
};

let RegistrationTypeSelectionComponent = props => {

    return (
        <div className="registration-component">

            <section className="main-section regn-home-wrapper">
                <div className="regn-home">
                    <div className="desc">
                        <div className="intro--large">
                            <p className="desc-heading">You can search for flights, book, track and quote without an
                                account.</p>
                        </div>
                        <div className="form-group btn-holder">
                            <LinkButton href={props.config.startbooking.url}
                               analytics={
                                   {
                                       "eventInfo": {
                                           "eventName":"continueAsGuest",
                                       },

                                       "attributes": {
                                           "destination":props.config.startbooking.url
                                       }
                                   }
                               }
                               >CONTINUE AS GUEST</LinkButton>
                        </div>
                        <div className="intro--large">
                            <p className="regist-us">Or you can register an account with us. </p>
                        </div>
                    </div>
                    <section className={"registration-section"}>
                        <div className="desc card-item">
                            <div className="card home-card">
                                <h3 className="card__heading">What you will need:</h3>
                                <div className="parsys">
                                    <div className="richtext section">
                                        <ul>
                                            <li>If you are an IATA agent, your agent number</li>
                                            <li>If your company is registered with us, your account number</li>
                                            <li>Your company address</li>
                                            <li>Your work email address</li>

                                        </ul>
                                    </div>
                                </div>
                                <SecondaryButton id={"secondary-register-btn"}

                                                 onClick={props.onRegisterClick} label="REGISTER"/>
                            </div>
                        </div>
                    </section>
                    <div className="desc">
                        <p className="footnote">Please note it will take up to 24 hours for us to set up your account
                            before you can start shipping to your account.</p>
                    </div>
                </div>
            </section>
        </div>
    );

};

RegistrationTypeSelectionComponent = connect(
    state => {
        return {
            config : getFormValues('config')(state)
        }
    }
)(RegistrationTypeSelectionComponent);


class RegistrationTypeSelectionContainer extends React.Component {


    componentWillMount = () => {
        if(!this.props.wizard.complete){
            AnalyticEvent(window.dataLayer,{
                "eventInfo": {
                "eventName":"registrationStep1",
            }}).then(()=> {}, () => {});
        }
    };

    componentWillUnmount = () => {
    };

    handleRegisterClick = () => {
        this.props.onRegisterClick();
    };

    render = () => {
        return (
            <RegistrationTypeSelectionComponent  onRegisterClick={this.handleRegisterClick}/>
        )
    }
}

RegistrationTypeSelectionContainer = connect(
    state => {
        return {
            wizard : getFormValues('wizard')(state),
            config : getFormValues('config')(state)
        }
    }
)(RegistrationTypeSelectionContainer);

RegistrationTypeSelectionContainer.defaultProps = {
    onRegisterClick : () => {}
};

export {RegistrationTypeSelectionContainer}